// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"42af03f5","93":"5b737d5d","170":"754963d1","268":"ddee6bd0","304":"6a22547c","374":"389c0514","536":"4ca00cde","552":"49ae1378","558":"ce7ae7b8","640":"fb4af651","666":"dcb3b877","923":"523f9ba6","955":"a9e78c39","981":"4deeea27"}[chunkId] + ".chunk.js";
};